import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import { makeStyles, Theme, Typography } from '@material-ui/core'
import AIDisclaimerDialog from 'components/AIDisclaimerDialog'
import React from 'react'

const useStyles = makeStyles((theme: Theme) => ({
    text: {
        color: '#304959',
        fontSize: pxToRem(14),
        lineHeight: pxToRem(20),
        marginBottom: theme.spacing(2),
        '&:last-child': {
            marginBottom: 0,
        },
    },
    bold: {
        fontWeight: 600,
    },
}))

/** Props for {@link SpecIntelligenceInfoDialog}. */
export interface SpecIntelligenceInfoDialogProps {
    /** Whether the dialog is open. */
    open: boolean
    /** Called when the dialog requests to be closed. */
    onClose: () => void
}

/** AI disclaimer dialog for Spec Intelligence, opened from the drawer info button. */
const SpecIntelligenceInfoDialog = ({ open, onClose }: SpecIntelligenceInfoDialogProps) => {
    const classes = useStyles()
    return (
        <AIDisclaimerDialog open={open} onClose={onClose}>
            <Typography className={classes.text}>
                This information is generated by an artificial intelligence tool exclusively using your Specpoint data and
                is subject to the Specpoint Product terms. AI‑generated outputs are not guaranteed to be accurate or complete
                and do not constitute representations or advice by Deltek.
                Deltek does not independently verify the accuracy of each output, and users are solely responsible for reviewing
                and validating them before any use. To report inaccurate or unexpected outputs, contact the Deltek Support Center.
                Copyright 2026 Deltek, Inc.
            </Typography>
        </AIDisclaimerDialog>
    )
}

export default SpecIntelligenceInfoDialog
